/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';

  /**
   * Хелпер для работы с объектами.
   * @type {{mergeDeep: Function}}
   */
  app.helpers.ObjectHelper = {

    /**
     * Мержит два объекта и если они содержат массивы, то мержит и их.
     * @param {Object} base Объект к которому нужно подмержить.
     * @param {Object} object Объект который подмерживают.
     * @returns {Object} Смерженный объект.
     */
    mergeDeep: function (base, object) {
      return _.mergeWith(base, object, this._filterMergeCustomizer);
    },
    /**
     * Метод для мержа массивов при использовании _.merge
     * @param obj
     * @param src
     *
     * @returns array|null
     */
    _filterMergeCustomizer: function (obj, src) {
      if (_.isArray(obj)) {
        return _.uniqWith(obj.concat(src), function (a, b) {
          return _.isEqual(String(a), String(b));
        });
      }
    },
  };
})();

}.call(window));